module.exports = __webpack_public_path__ + "img/Pasquale.a47c223d.jpg";